import React, { useEffect, useState } from "react";
import { adminDeleteSpecificUser } from "@services/users.service";
import { getValue } from "@utils/lodash";
// import "./user.scss";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { useNavigate } from "react-router-dom";
import PaginationPage from "@components/pagination/pagination";
import NavigationBar from "@components/NotificationBar";
import { Button, Modal } from "reactstrap";
import { toast } from "react-toastify";
import DeleteModal from "@_common/deleteModal";
import Notfound from "@components/Not-Found";
import {
  adminCreateGroup,
  adminGetGroups,
  adminUpdateBulkGroupStatus,
  adminUpdateSpecificGroup,
} from "@services/groups.service";
import Search from "@components/common/Search";
import InputField from "@_common/InputRuleFeild";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { adminAllCrons, getAllLogs } from "@services/license.service";
import { formatText } from "@_common/format-text";
import moment from "moment";
import NoAccessPage from "@components/common/NoAccess";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { useParams } from "react-router-dom";
import { getComplianceReports } from "@services/reports.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import FooterWrapper from "../FooterWrapper";
import SearchHeader from "../SearchHeader";
import MoreConfigSvgComponent from "../../../assets/svg-components/left-menu/more-config";
import MenuRepositorySvgComponent from "../../../assets/svg-components/left-menu/menurepo";
import MenuActivitySvgComponent from "../../../assets/svg-components/left-menu/menuactivity";
import RightMenuHeaders from "../RightMenuHeaders";
import ViewLogNotfound from "@components/Page-Not-Found/view-log-not-found";
import { deleteExports } from "@services/import.service";
interface IAdminUsersProps {}

const SelfComplianceLogs: React.FunctionComponent<IAdminUsersProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let mainParams = useParams();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [usersList, setUsersList] = React.useState<[]>([]);
  const [group_name, setGroup_name] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState("");

  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const handleModalCancel = () => {
    setIsOpen(!isOpen);
    setEdit(false);
    setEditId("");
    setGroup_name("");
  };
  const handleModalEdit = (item: object) => {
    setEdit(true);
    setGroup_name(getValue(item, `group_name`, ""));
    setEditId(getValue(item, `id`, ""));
    handleModal();
  };
  const [allStatus] = useState([
    { value: "", label: "All" },
    { value: "STARTED", label: "Started" },
    { value: "STOPPED", label: "Stopped" },
    { value: "SUCCESS", label: "Success" },
    { value: "FAILED", label: "Failed" },
  ]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const mainParam = useParams();
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
      report_type: getValue(mainParam, `type`, ""),
      sortBy: "newest",
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getComplianceReports(queryRequest);
      if (resp) {
        setUsersList(
          getValue(resp, `data.reports`, []).map((item: object) => ({
            ...item,
            status: getValue(item, `queue_status`, "")
              ? formatText(getValue(item, `queue_status`, ""))
              : "",
            report_formatted: getValue(item, `report_name`, "")
              // ? formatText(getValue(item, `report_name`, ""))
              // : ""
              ,
            created_at: getValue(item, `created_at`, "")
              ? moment(getValue(item, `created_at`, "")).format(
                  "DD MMM YYYY, hh:mm a"
                )
              : "",
            updated_by:
              getValue(item, `user.first_name`, "") +
              " " +
              getValue(item, `user.last_name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (edit) {
      try {
        let resp = await adminUpdateSpecificGroup(editId, {
          group_name: group_name,
        });
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          handleModal();
          getData();
          setGroup_name("");
          setEdit(false);
          setEditId("");
        }
      } catch (error) {}
    } else {
      try {
        let resp = await adminCreateGroup({ group_name: group_name });
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          handleModal();
          getData();
          setGroup_name("");
        }
      } catch (error) {}
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setSearchInput(e.target.value);

    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (value) {
      let payload = {
        ...params,
        status: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.status;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      usersList.length > 0
        ? usersList.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    handleModalEdit(getValue(obj, `original`, ""));
  };

  const rowClickUpdate = () => {};

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificUser(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string, module: string) => {
    navigate(`/admin/schedules/logs/${id}/${module}`);
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  const handleRemoveRecord = async (deleteId:any) => {
    try {
      const idsArray = Array.isArray(deleteId) ? deleteId : [deleteId];
      let resp = await deleteExports({ ids: idsArray });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        getData();
      }
    } catch (error) {
      
    }
  }

  const columns = React.useMemo(
    () => [
      // {
      // 	Header: "Job ID",
      // 	accessor: "job_id",
      // 	width: 150,
      // 	Cell: ({ row }: any) => {
      // 		return (
      // 			// <div onClick={() => handleModalEdit(row.original)}>
      // 			<p>{getValue(row, `values.job_id`, "")}</p>
      // 			// </div>
      // 		);
      // 	},
      // },
      {
        Header: "Report Name",
        accessor: "report_formatted",
        width: 350,
      },
      // {
      // 	Header: "Attached Count",
      // 	accessor: "attatched_count",
      // 	width: 100,
      // },
      // {
      // 	Header: "Inserted Count",
      // 	accessor: "inserted_count",
      // 	width: 100,
      // },
      // {
      // 	Header: "Removed Count",
      // 	accessor: "removed_count",
      // 	width: 100,
      // },
      // {
      // 	Header: "Failed Count",
      // 	accessor: "failed_count",
      // 	width: 100,
      // },
      // {
      // 	Header: "Updated Count",
      // 	accessor: "updated_count",
      // 	width: 100,
      // },
      // {
      // 	Header: "Total Count",
      // 	accessor: "total_count",
      // 	width: 100,
      // },
      {
        Header: "Updated By",
        accessor: "updated_by",
        width: 150,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 150,
      },
      {
        Header: "Create At",
        accessor: "created_at",
        width: 150,
      },
      {
        Header: "Download",
        width: 200,
        Cell: ({ row }: any) => {
          return (
            !row.original.is_verified && (
              <div className="table_download_container">
                <div className="d-flex">
                  <button
                    className="resend-btn d-flex align-items-center"
                    onClick={(e) =>
                      handleDownloadOnClick(
                        getValue(row, `original.report_url`, ""),
                        getValue(row, `original.report_name`, "")
                      )
                    }
                    style={{
                      color: getValue(row, `original.report_url`, "")
                        ? "#1A73E8"
                        : "black",
                    }}
                    disabled={!getValue(row, `original.report_url`, "")}
                  >
                    {getValue(row, `original.report_url`, "") ? (
                      <img
                        src="/images/download.svg"
                        className="img-fluid d-block"
                      />
                    ) : getValue(row, `original.status`, "") === "Failed" ? (
                      "Failed"
                    ) : (
                      <img
                        src="/images/clock.svg"
                        className="img-fluid d-block"
                        style={{
                          height: "18px",
                          width: "18px",
                          marginRight: "5px",
                        }}
                      />
                    )}
                    {getValue(row, `original.report_url`, "") ? (
                      "Download"
                    ) : !getValue(row, `original.report_url`, "") &&
                      getValue(row, `original.queue_status`, "") ===
                        "COMPLETED" ? (
                      "URL Not Found"
                    ) : getValue(row, `original.status`, "") === "Failed" ? (
                      ""
                    ) : (
                      <p>Processing</p>
                    )}
                  </button>
                  {!getValue(row, `original.report_url`, "") &&
                    getValue(row, `original.status`, "") !== "Failed" &&
                    getValue(row, `original.queue_status`, "") !==
                      "COMPLETED" && (
                      <img
                        src="/images/reload.svg"
                        className="img-fluid d-block"
                        style={{
                          height: "22px",
                          width: "22px",
                          marginLeft: "10px",
                        }}
                        onClick={() => getData()}
                      />
                    )}
                </div>
            {getValue(row, `original.queue_status`, "") !== "COMPLETED" ? 
                <button
                  className="resend-btn d-flex align-items-center mt-2"
                  onClick={(e) =>
                    handleRemoveRecord(
                      getValue(row, `original.id`, "")
                    )
                  }
                  style={{ color: "#d7242e" }}
                >
                    <div className="d-flex align-items-center">
                      <img
                        src="/images/close-red.svg"
                        className="img-fluid d-block"
                      />
                      Remove
                    </div>
                </button>
              : ""}
              </div>
            )
          );
        },
      },
    ],
    []
  );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminUpdateBulkGroupStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  const CheckRootName = () => {
    switch (getValue(mainParams, `type`, "")) {
      case "SELFCOMP_MASTER":
        return "Repository Master";
      case "SELFCOMP_FUNCTION_HEAD":
        return "Repository Function Header";
      case "SELFCOMP_EVALUATOR":
        return "Repository Evaluator";

      case "SELFCOMP_MY_TASKS":
        return "Activity My Tasks";
      case "SELFCOMP_PENDING_APPROVAL":
        return "Activity Pending Approval";
      case "SELFCOMP_APPROVED_TASK":
        return "Activity Approved Task";

      default:
        return "";
    }
  };

  const handleNavigateBack = () => {
    switch (getValue(mainParams, `type`, "")) {
      case "SELFCOMP_MASTER":
        return navigate("/repository/mapped-checkpoint/master");
      case "SELFCOMP_FUNCTION_HEAD":
        return navigate("/repository/mapped-checkpoint/function-head");
      case "SELFCOMP_EVALUATOR":
        return navigate("/repository/mapped-checkpoint/evaluator");

      case "SELFCOMP_MY_TASKS":
        return navigate("/activities/self-compliance/my-task");
      case "SELFCOMP_PENDING_APPROVAL":
        return navigate("/activities/self-compliance/pending-approval");
      case "SELFCOMP_APPROVED_TASK":
        return navigate("/activities/self-compliance/approved-task");

      default:
        return "#";
    }
  };

  const getHeaderIcon = () => {
    switch (getValue(mainParams, `type`, "")) {
      case "SELFCOMP_MASTER":
        return <MenuRepositorySvgComponent />;
      case "SELFCOMP_FUNCTION_HEAD":
        return <MenuRepositorySvgComponent />;
      case "SELFCOMP_EVALUATOR":
        return <MenuRepositorySvgComponent />;
      case "SELFCOMP_MY_TASKS":
        return <MenuActivitySvgComponent />;
      case "SELFCOMP_PENDING_APPROVAL":
        return <MenuActivitySvgComponent />;;
      case "SELFCOMP_APPROVED_TASK":
        return <MenuActivitySvgComponent />;;
      default:
        return "#";
    }
  };

  const getHeaderParentTitle = () => {
    switch (getValue(mainParams, `type`, "")) {
      case "SELFCOMP_MASTER":
        return <>Master</>;
      case "SELFCOMP_FUNCTION_HEAD":
        return <>Function Head</>;
      case "SELFCOMP_EVALUATOR":
        return <>Evaluator</>;
      case "SELFCOMP_MY_TASKS":
        return <>Executor Task</>;
      case "SELFCOMP_PENDING_APPROVAL":
        return <>Evaluator Approval</>;;
      case "SELFCOMP_APPROVED_TASK":
        return <>Completed Task</>;;
      default:
        return "#";
    }
  };
  return (
    <>
      <DashboardLayout
        permissions={getValue(props, `tabPermissionList`, [])}
        subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
      >
        {/* {!isLoading && 
				!getValue(props, `subTabPermissionList`, []).includes("admin_system_audit_log") ? (
					<NoAccessPage />
				) : ( */}
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              multi={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleRemoveNavItems={handleRemoveNavItems}
              permissions={getValue(props, `permissions`, [])}
            />
          )}

          {/* <div className="dashboard-wrapper__header">
            <div className="d-flex">
              <div
                onClick={() => handleNavigateBack()}
                className="cursor-pointer"
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid add-filter-wrapper__upload-image"
                />
                &nbsp;&nbsp;&nbsp;
              </div>

              <h4 className="dashbaord-wrapper__header-title">
                {CheckRootName()} Logs
              </h4>
            </div>
          </div> */}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              {/* <div
                onClick={() => handleNavigateBack()}
                className="cursor-pointer me-2"
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid add-filter-wrapper__upload-image"
                />
              </div> */}

              <div className="header-parent-icon-holder d-flex justify-content-center">
                {/* {getHeaderIcon()} */}
                L
              </div>

              <div className="title-wrapper">
                {/* <h6 className="dashbaord-wrapper__header-parent-title">
                  {getHeaderParentTitle()}
                </h6> */}
                <h4 className="dashbaord-wrapper__header-title">
                  {CheckRootName()} Logs
                </h4>
              </div>
            </div>

            <div>
              <RightMenuHeaders
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
              />
            </div>
          </div>

          <div className="main-page-layout-wrapper" id={
              getValue(selectedIDs, `length`, 0) > 0
                ? "blueNavigationVisible"
                : ""
            }>
            <div className="admin-wrapper position-relative d-none">
              <SearchHeader
                route={"/report/vendor-audit/add"}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                smartFilter={false}
                locationUpload={true}
                // search={"false"}
                add={"false"}
              />
            </div>
            <div className="admin-wrapper">
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : usersList.length > 0 ? (
                getValue(props, `permissions`, []).includes("update") ? (
                  <ScrollableReactTable
                    columns={columns}
                    data={usersList}
                    getTableState={getTableState}
                    rowClick={rowClick}
                    check={check}
                    selectedIDs={selectedIDs}
                    checkboxlogo
                    getTrProps={getTrProps}
                  />
                ) : (
                  <ScrollableReactTable
                    columns={columns}
                    data={usersList}
                    getTableState={getTableState}
                    rowClick={rowClickUpdate}
                    check={check}
                    selectedIDs={selectedIDs}
                    checkboxlogo
                    getTrProps={getTrProps}
                  />
                )
              ) : (
                <>
                  <>
                    {Object.keys(params).length !== 0 ? (
                      <ViewLogNotfound />
                    ) : (
                      <ViewLogNotfound />
                    )}
                  </>
                </>
              )}
            </div>
            <FooterWrapper
              list={usersList}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
            <DeleteModal
              isOpen={isDelete}
              handleModal={handleDelete}
              handleSubmit={handleDeleteFunction}
              deleteValue={deleteValue}
            />
          </div>
          {/* <Modal
            isOpen={isOpen}
            centered

            // toggle={isOpen}
          >
            <section className="add-popup-wrapper">
              <div className="add-popup-wrapper__popup p-5">
                <div className="add-popup-wrapper__form-group form-group">
                  <h3>Groups</h3>
                </div>
                <InputField
                  inputType="TEXT"
                  value={group_name}
                  onChange={(e: any) => setGroup_name(e.target.value)}
                  name="group_name"
                  id="group_name"
                  placeholder={"Enter Group Name"}
                />
                <div className="add-popup-wrapper__cta-wrapper">
                  <button
                    onClick={handleModalCancel}
                    className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
                  >
                    Cancel
                  </button>
                  <button
                    className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </section>
          </Modal> */}
        </>
        {/* )}  */}
      </DashboardLayout>{" "}
    </>
  );
};

export default SelfComplianceLogs;
